<app-group-of-rules
  [index]="0"
  [level]="1"
  [deepLevel]="5"
  [disableRemove]="true"
  [groupRuleInput]="groupRuleInput"
  (groupChangeEvent)="onValueChanged($event)"></app-group-of-rules>
<!--<ng-container *ngIf="queryString;">-->
<!--  <span class="fs-12"><strong>Condition:</strong> {{ queryString }}</span>-->
<!--</ng-container>-->
